module.exports = __webpack_public_path__ + "img/ms.a9d39520.svg";